module.exports = __webpack_public_path__ + "static/media/profile.b3692dd0.png";